export default "__VITE_ASSET__jqDUD5Nn__"